import { add, subtract, vn } from 'vend-number'
import { ReduxCurrentSale } from '../state/slices/currentSale/currentSaleSlice'
import { Payment } from '../models/payment'
import { isValidCustomer } from './sale'

type getAdjustedAccountBalanceParams = Pick<
  ReduxCurrentSale,
  'customer' | 'customerBalances' | 'id' | 'paidBalance' | 'finals' | 'payments'
>

export const getAdjustedAccountBalance = (
  sale: getAdjustedAccountBalanceParams
): number => {
  if (!isValidCustomer(sale.customer) || !sale.customerBalances) {
    return 0
  }
  const payments = sale.payments
  const amountPaid =
    sale.id && vn(sale.paidBalance!).gt(0)
      ? subtract(vn(sale.finals.inclusivePrice), vn(sale.paidBalance!))
      : vn(sale.finals.inclusivePrice)

  let adjustedBalance = subtract(sale.customerBalances.account, amountPaid)

  // Check if any partial payments were made
  if (payments.length) {
    // Only add payments to the balance that haven't been posted to the API
    // or if the adjustment is being made to an existing on account / layby sale
    const totalPartialPayments = payments.reduce(
      (total: number, payment: Payment) => {
        if (!payment.retrieved || (payment.retrieved && sale.id)) {
          return add(total, payment.amount)
        } else {
          return total
        }
      },
      0
    )
    adjustedBalance = add(adjustedBalance, vn(totalPartialPayments))
  }
  return adjustedBalance
}
